module.exports = __webpack_public_path__ + "static/media/arab09.0100bb79.wav";